import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";
import H1 from "../H1";
import H2 from "../H2";
import { EMOJI, OPEN_QANDA, POLL, calculatePercentage } from "../QandA";
import { checkForOverride } from "../helpers/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";


export default function InteractionCurrentQuestion ({ cue }) {
  let { projectId } = useParams()
	const dynamicText = useSelector(
		(state) => state.main?.projects?.[projectId]?.dynamicText
	);
  const selectedProject = useSelector(
		(state) => state?.main?.projects?.[projectId]
	);

  const baseTheme = useSelector((state) =>
  cue.theme
    ? state?.main?.projects?.[projectId]?.themes?.[cue.theme]
    : state?.main?.projects?.[projectId]?.themes?.[selectedProject?.theme]
	);
	const baseThemeId = cue.theme ? cue.theme : projectId?.theme;


  const questionContents = {
    [OPEN_QANDA]: <OpenQandAContent cue={cue} questionId={dynamicText['qanda.currentQuestionId']} options={dynamicText['qanda.currentQuestionOptions']} results={dynamicText['qanda.currentQuestionResults']} showOnOutputIndex={dynamicText['qanda.currentQuestionResultsShowOnOutputIndex']} baseTheme={baseTheme} baseThemeId={baseThemeId}/>,
    [EMOJI]: <EmojiContent cue={cue} questionId={dynamicText['qanda.currentQuestionId']} options={dynamicText['qanda.currentQuestionOptions']} results={dynamicText['qanda.currentQuestionResults']} baseTheme={baseTheme} baseThemeId={baseThemeId}/>,
    [POLL]: <PollContent cue={cue} questionId={dynamicText['qanda.currentQuestionId']} options={dynamicText['qanda.currentQuestionOptions']} results={dynamicText['qanda.currentQuestionResults']} totalCount={dynamicText['qanda.currentQuestionResultsTotalCount']} baseTheme={baseTheme} baseThemeId={baseThemeId}/>,
  }

  console.log(dynamicText)
  return (
    <div className="w-full mb-s2">
      <H1 cue={cue} text={dynamicText['qanda.currentQuestion']} baseTheme={baseTheme} baseThemeId={baseThemeId} />

      {/* {dynamicText['qanda.currentQuestionOptions'].length ? dynamicText['qanda.currentQuestionOptions']?.map((option)=> {
        return (
          <H2 key={option.id} cue={cue} text={option.text} baseTheme={baseTheme} baseThemeId={baseThemeId} />
        )
      }) : ''} */}

      {dynamicText['qanda.loading'] ? 
      <FontAwesomeIcon icon={faSpinner} className="animate-spin" /> 
      : <div className="">
        {questionContents[dynamicText['qanda.currentQuestionType']]}
      </div>}

    </div>
  )
}



const EmojiContent = ({ options = [], results, baseTheme, cue }) => {

  return (
    <div className="mt-s4 flex gap-4 justify-center">
      {options.length && options?.map((option, index) => {
        return (
          <div
            key={option.id}
            className="p-s5 pb-s2 rounded text-4xl"
            style={{
              background: checkForOverride(baseTheme, cue.type, cue.theme, 'background', "colour2"),
            }}
          >
            <div>{option.text}</div>
            <p className={[
              "pt-s1 text-center text-base font-semibold",
            ].join(' ')}
            
            >{results?.[index] || 0}</p>
          </div>
        )
      })}
    </div>
  )
}

const PollContent = ({ cue, options = [], results, totalCount, baseTheme, baseThemeId, questionId }) => {

  return (
    <div className="mt-s4 flex flex-col space-y-2">
     <div
      className={`rounded flex justify-between items-center
     `}
     >

     </div>
     <div className="flex flex-col space-y-2">
      {options.length && options?.map((option, index) => {
       return (
        <div
         key={`${questionId}_${index}`}
         className="relative rounded flex w-full items-center"
         style={{
          background: checkForOverride(baseTheme, cue.type, cue.theme, 'background', "colour2"),
        }}
        >
         <span
          style={{
           width: `${calculatePercentage(
            results?.[index],
            parseInt(totalCount)
           )}`,
           background: checkForOverride(baseTheme, cue.type, cue.theme, 'background', "colour"),
          }}
          className="absolute rounded h-full w-100 opacity-40 z-0 transition-all duration-300"
         ></span>
         <div className="px-s2 z-10">
          <H2 cue={cue} text={`${index + 1}`} baseTheme={baseTheme} baseThemeId={baseThemeId} styled={false} />{" "}
         </div>
         
         <div
          className="flex z-10 justify-between w-full"
         >
          <div className="py-s2"><H2 cue={cue} text={option.text} baseTheme={baseTheme} baseThemeId={baseThemeId} styled={false} /></div>{" "}
          <span className="mr-s2 z-10 opacity-80 my-auto">
           {results?.[index] > 0 &&
            <H2 cue={cue} text={`${calculatePercentage(results?.[index], parseInt(totalCount))}`} baseTheme={baseTheme} baseThemeId={baseThemeId} styled={false} />
            }
          </span>
         </div>
        </div>
       );
      })}
     </div>
    </div>
   );
}

const OpenQandAContent = ({ options = [], results = [], baseTheme, cue, baseThemeId, showOnOutputIndex }) => {

  if (!results || !results.length || (showOnOutputIndex === null)) return null
  return (
    <div className="mt-s4 flex flex-col gap-4 justify-left">
      {results?.map((result, index) => {
        if(index !== showOnOutputIndex) return null
        return (
          <div
            key={index}
            className="px-s2 py-s1 rounded text-xl w-full"
            style={{
              background: checkForOverride(baseTheme, cue.type, cue.theme, 'background', "colour2"),
            }}
          >
            <H2 cue={cue} text={`${result.text} • ${result.name}`} baseTheme={baseTheme} baseThemeId={baseThemeId} styled={false} />
            <div></div>
          </div>
        )
      })}
    </div>
  )
}